"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import Auth from "../util/auth";
import { managedIndexerSwitcherServiceShow } from "./data/types/Api";
import {
  decodeManagedIndexerSwitcher,
  encodeManagedIndexerSwitcher,
  ManagedIndexerAccountPriority
} from "./data/types/Pb";
const REFRESH_MS = 9e4;
const HELD_RETRY_MS = 1e3;
const SESSION_CACHE_KEY = "managed-indexer-switcher";
const SESSION_CACHE_MAX_AGE_MS = 5 * 6e4;
const NAME_MAX_PX = 200;
const LEGACY_NAME_CHARS = 24;
const ACCOUNT_LIST_ID = "header-menu--account-list";
const LEGACY_SELECT_CLASS = "group-users-select";
const LATE_COLOR = "#FF5C5C";
const DUE_COLOR = "#A8D9E6";
const MUTED_COLOR = "#939A9F";
const CURRENT_ACCOUNT_COLOR = "var(--color-blue-600)";
let shown = null;
let held;
let refreshTimer;
let heldTimer;
let notify = () => {
};
export function formatDuration(minutes) {
  const total = Math.floor(Math.abs(minutes));
  return `${Math.floor(total / 60)}h ${String(total % 60).padStart(2, "0")}m`;
}
function isEmpty(stats) {
  return stats.itemCount === 0 || stats.oldestDueInMinutes === null;
}
function isLate(stats) {
  var _a;
  return !!stats && !isEmpty(stats) && ((_a = stats.oldestDueInMinutes) != null ? _a : 0) < 0;
}
export function statusColumn(stats) {
  var _a;
  if (isEmpty(stats)) {
    return { text: "empty", color: MUTED_COLOR };
  }
  const minutes = (_a = stats.oldestDueInMinutes) != null ? _a : 0;
  const word = minutes < 0 ? "late" : "due";
  return {
    text: word.padEnd(5) + formatDuration(minutes).padStart(7),
    color: minutes < 0 ? LATE_COLOR : DUE_COLOR
  };
}
function slaTier(stats) {
  if (!stats) return 2;
  return isEmpty(stats) ? 1 : 0;
}
function bySlaUrgency(a, b) {
  var _a, _b, _c, _d;
  return slaTier(a.stats) - slaTier(b.stats) || ((_b = (_a = a.stats) == null ? void 0 : _a.oldestDueInMinutes) != null ? _b : 0) - ((_d = (_c = b.stats) == null ? void 0 : _c.oldestDueInMinutes) != null ? _d : 0) || a.name.localeCompare(b.name);
}
function statsAt(account, elapsedMinutes) {
  if ((account == null ? void 0 : account.item_count) == null) return null;
  return {
    itemCount: account.item_count,
    oldestDueInMinutes: account.oldest_due_in_minutes == null ? null : account.oldest_due_in_minutes - elapsedMinutes
  };
}
export function switcherRows(groupUsers, snapshot, now) {
  const elapsedMinutes = Math.floor((now - snapshot.fetchedAt) / 6e4);
  const accounts = groupUsers.map((groupUser) => ({
    kind: "account",
    userId: groupUser.user_id,
    name: groupUser.account_name,
    stats: snapshot.stats ? statsAt(snapshot.stats.get(groupUser.user_id), elapsedMinutes) : null
  }));
  const sortBy = snapshot.stats ? bySlaUrgency : (a, b) => a.name.localeCompare(b.name);
  const section = (title, rows) => {
    if (rows.length === 0) return [];
    const late = rows.filter((row) => isLate(row.stats)).length;
    const heading = late > 0 ? `${title} \xB7 ${late} late` : title;
    return [{ kind: "heading", title: heading }, ...[...rows].sort(sortBy)];
  };
  const withPriority = (priority) => accounts.filter(
    (a) => {
      var _a;
      return ((_a = snapshot.priorities.get(a.userId)) != null ? _a : ManagedIndexerAccountPriority.ManagedIndexerAccountPriorityNone) === priority;
    }
  );
  return [
    ...section(
      "Primary",
      withPriority(
        ManagedIndexerAccountPriority.ManagedIndexerAccountPriorityPrimary
      )
    ),
    ...section(
      "Secondary",
      withPriority(
        ManagedIndexerAccountPriority.ManagedIndexerAccountPrioritySecondary
      )
    ),
    ...section(
      "Other accounts",
      withPriority(
        ManagedIndexerAccountPriority.ManagedIndexerAccountPriorityNone
      )
    )
  ];
}
let measureContext;
function textWidth(text) {
  if (measureContext === void 0) {
    measureContext = document.createElement("canvas").getContext("2d");
  }
  if (!measureContext) return 0;
  measureContext.font = "600 14px Inter, sans-serif";
  return measureContext.measureText(text).width;
}
export function fitName(name, measure = textWidth) {
  if (measure(name) <= NAME_MAX_PX) return name;
  let length = name.length - 1;
  while (length > 4 && measure(name.slice(0, length).trimEnd() + "\u2026") > NAME_MAX_PX) {
    length--;
  }
  return name.slice(0, length).trimEnd() + "\u2026";
}
export function currentRows(user) {
  var _a;
  if (!shown || !(user == null ? void 0 : user.managed_indexer) || !((_a = user.group_user_info) == null ? void 0 : _a.length)) {
    return null;
  }
  return switcherRows(user.group_user_info, shown, Date.now());
}
function hasAnyStats(rows) {
  return rows.some((row) => row.kind === "account" && !!row.stats);
}
export function headerAccountsForRows(rows, currentUserId) {
  const hasStats = hasAnyStats(rows);
  return rows.map(
    (row) => row.kind === "heading" ? (
      // Pointing a heading at the current user makes any click that gets through a no-op switch.
      { id: currentUserId, name: row.title, isCurrent: false }
    ) : {
      id: row.userId,
      name: hasStats ? fitName(row.name) : row.name,
      isCurrent: row.userId === currentUserId
    }
  );
}
export function managedIndexerHeaderAccounts(user) {
  const rows = currentRows(user);
  return rows && user ? headerAccountsForRows(rows, user.id) : null;
}
function cssString(value) {
  return `"${value.replace(/["\\]/g, "\\$&")}"`;
}
export function switcherCss(rows, currentUserId) {
  const list = `#${ACCOUNT_LIST_ID}`;
  const nth = (index) => `${list} > :nth-child(${index + 1})`;
  const hasStats = hasAnyStats(rows);
  const rules = [
    `${list} > * .header__menu-btn { padding-left: 16px !important; flex-wrap: nowrap !important; align-items: baseline !important; }`,
    // elm-ui marks the current account on the name, which now sits after the status column, so
    // the marker moves to the start of the row.
    `${list} > * .header__menu-btn span { padding-left: 0 !important; white-space: nowrap; box-shadow: none !important; }`
  ];
  if (hasStats) {
    rules.push(
      `${list} > * .header__menu-btn::before { flex: 0 0 auto; width: 13.5ch; white-space: pre; font: 600 12px ui-monospace, SFMono-Regular, Menlo, monospace; }`,
      `${list} > * .header__menu-btn::after { flex: 0 0 auto; margin-left: auto; padding-left: 20px; min-width: 44px; text-align: right; color: ${MUTED_COLOR}; font-size: 13px; font-variant-numeric: tabular-nums; }`
    );
  }
  rows.forEach((row, index) => {
    if (row.kind === "heading") {
      rules.push(
        `${nth(index)} { pointer-events: none;${index > 0 ? " border-top: 1px solid rgb(255 255 255 / 0.12); margin-top: 6px;" : ""} }`,
        `${nth(index)} .header__menu-btn { background: transparent !important; cursor: default; padding: 14px 12px 6px 12px !important; }`,
        `${nth(index)} span { color: ${MUTED_COLOR} !important; font-size: 11px !important; letter-spacing: 0.08em; text-transform: uppercase; box-shadow: none !important; }`
      );
    } else {
      if (row.userId === currentUserId) {
        rules.push(
          `${nth(index)} .header__menu-btn { box-shadow: inset 2px 0 ${CURRENT_ACCOUNT_COLOR}; }`
        );
      }
      if (!row.stats) {
        if (hasStats) {
          rules.push(
            `${nth(index)} .header__menu-btn::before { content: ""; }`
          );
        }
        return;
      }
      const status = statusColumn(row.stats);
      const count = row.stats.itemCount > 0 ? String(row.stats.itemCount) : "";
      rules.push(
        `${nth(index)} .header__menu-btn::before { content: ${cssString(status.text)}; color: ${status.color}; }`,
        `${nth(index)} .header__menu-btn::after { content: ${cssString(count)}; }`
      );
    }
  });
  return rules.join("\n");
}
function toLowercaseAlphanumeric(text) {
  return text.toLowerCase().replace(/[^a-z0-9]/g, "");
}
export function matchesSearch(name, query) {
  return toLowercaseAlphanumeric(name).includes(toLowercaseAlphanumeric(query));
}
export function matchingRowIndexes(rows, query) {
  return rows.flatMap(
    (row, index) => row.kind === "account" && matchesSearch(row.name, query) ? [index] : []
  );
}
export function searchCss(rows, query, activeRowIndex, minWidth) {
  const list = `#${ACCOUNT_LIST_ID}`;
  const nth = (index) => `${list} > :nth-child(${index + 1})`;
  const matching = new Set(matchingRowIndexes(rows, query));
  const bandPx = matching.size === 0 ? SEARCH_BAND_PX + SEARCH_EMPTY_PX : SEARCH_BAND_PX;
  const rules = [
    `${list} { padding-top: ${bandPx}px !important; min-width: ${minWidth}px; }`
  ];
  let headingIndex = -1;
  let headingHasMatch = false;
  const closeSection = () => {
    if (headingIndex >= 0 && !headingHasMatch) {
      rules.push(`${nth(headingIndex)} { display: none; }`);
    }
  };
  rows.forEach((row, index) => {
    if (row.kind === "heading") {
      closeSection();
      headingIndex = index;
      headingHasMatch = false;
    } else if (matching.has(index)) {
      headingHasMatch = true;
    } else {
      rules.push(`${nth(index)} { display: none; }`);
    }
  });
  closeSection();
  if (activeRowIndex !== null) {
    rules.push(
      `${nth(activeRowIndex)} .header__menu-btn { background: rgb(255 255 255 / 0.2) !important; }`
    );
  }
  return rules.join("\n");
}
const SEARCH_BAND_PX = 50;
const SEARCH_EMPTY_PX = 32;
const SEARCH_CLASS = "managed-indexer-switcher-search";
const SEARCH_CSS = `
.${SEARCH_CLASS} { position: fixed; z-index: 1001; box-sizing: border-box; padding: 8px; min-height: ${SEARCH_BAND_PX}px; background: #22134E; border-radius: 8px; }
input.${SEARCH_CLASS}__input { display: block; width: 100% !important; height: 34px !important; margin: 0 !important; box-sizing: border-box !important; border-radius: 6px !important; border: 1px solid rgb(255 255 255 / 0.2) !important; background: rgb(255 255 255 / 0.08) !important; color: #FFFFFF !important; padding: 0 10px !important; font: 500 14px Inter, sans-serif !important; outline: none !important; box-shadow: none !important; transition: none !important; }
input.${SEARCH_CLASS}__input::placeholder { color: ${MUTED_COLOR}; }
input.${SEARCH_CLASS}__input:focus { border-color: ${DUE_COLOR} !important; }
.${SEARCH_CLASS}__empty { color: ${MUTED_COLOR}; font: 13px Inter, sans-serif; padding: 10px 4px 0; }
`;
function trackDropdownBox(previous) {
  var _a;
  const list = document.getElementById(ACCOUNT_LIST_ID);
  if (!list) return null;
  const rect = list.getBoundingClientRect();
  const next = {
    top: rect.top,
    left: rect.left,
    width: rect.width,
    openWidth: (_a = previous == null ? void 0 : previous.openWidth) != null ? _a : rect.width
  };
  const unchanged = previous && previous.top === next.top && previous.left === next.left && previous.width === next.width;
  return unchanged ? previous : next;
}
function clickRow(rowIndex) {
  var _a;
  (_a = document.querySelector(
    `#${ACCOUNT_LIST_ID} > :nth-child(${rowIndex + 1}) .header__menu-btn`
  )) == null ? void 0 : _a.click();
}
function scrollListToTop() {
  const list = document.getElementById(ACCOUNT_LIST_ID);
  if (list) list.scrollTop = 0;
}
function scrollRowIntoView(rowIndex, bandPx) {
  const list = document.getElementById(ACCOUNT_LIST_ID);
  const row = list == null ? void 0 : list.children[rowIndex];
  if (!list || !row) return;
  const listRect = list.getBoundingClientRect();
  const rowRect = row.getBoundingClientRect();
  const visibleTop = listRect.top + bandPx;
  if (rowRect.top < visibleTop) {
    list.scrollTop -= visibleTop - rowRect.top;
  } else if (rowRect.bottom > listRect.bottom) {
    list.scrollTop += rowRect.bottom - listRect.bottom;
  }
}
function SwitcherSearch({
  rows,
  box
}) {
  const [query, setQuery] = useState("");
  const [active, setActive] = useState(0);
  const inputRef = useRef(null);
  useEffect(() => {
    var _a;
    (_a = inputRef.current) == null ? void 0 : _a.focus();
    let second = 0;
    const first = requestAnimationFrame(() => {
      second = requestAnimationFrame(scrollListToTop);
    });
    return () => {
      cancelAnimationFrame(first);
      cancelAnimationFrame(second);
    };
  }, []);
  const matching = matchingRowIndexes(rows, query);
  const activeRowIndex = matching.length > 0 ? matching[Math.min(active, matching.length - 1)] : null;
  const bandPx = matching.length === 0 ? SEARCH_BAND_PX + SEARCH_EMPTY_PX : SEARCH_BAND_PX;
  useEffect(() => {
    scrollListToTop();
  }, [query]);
  useEffect(() => {
    if (activeRowIndex !== null) scrollRowIntoView(activeRowIndex, bandPx);
  }, [activeRowIndex, bandPx]);
  const onKeyDown = (event) => {
    var _a;
    if (event.key === "ArrowDown") {
      event.preventDefault();
      setActive(Math.min(active + 1, Math.max(matching.length - 1, 0)));
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      setActive(Math.max(active - 1, 0));
    } else if (event.key === "Enter") {
      if (event.nativeEvent.isComposing) return;
      if (activeRowIndex !== null) clickRow(activeRowIndex);
    } else if (event.key === "Escape") {
      (_a = document.querySelector(".header__menu-btn--open")) == null ? void 0 : _a.click();
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("style", { children: SEARCH_CSS + searchCss(rows, query, activeRowIndex, box.openWidth) }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: SEARCH_CLASS,
        style: {
          top: box.top,
          left: box.left,
          width: Math.max(box.width, box.openWidth)
        },
        children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              ref: inputRef,
              className: `${SEARCH_CLASS}__input`,
              type: "text",
              placeholder: "Search accounts",
              autoComplete: "off",
              spellCheck: false,
              value: query,
              onChange: (event) => {
                setQuery(event.target.value);
                setActive(0);
              },
              onKeyDown
            }
          ),
          matching.length === 0 && /* @__PURE__ */ jsxs("div", { className: `${SEARCH_CLASS}__empty`, children: [
            "No accounts match \u201C",
            query.trim(),
            "\u201D"
          ] })
        ]
      }
    )
  ] });
}
export function ManagedIndexerSwitcherOverlay() {
  const user = Auth.getCurrentUser();
  const rows = currentRows(user);
  const enabled = !!rows;
  const [box, setBox] = useState(null);
  useEffect(() => {
    if (!enabled) return;
    const update = () => setBox(trackDropdownBox);
    const observer = new MutationObserver(update);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, true);
    update();
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update, true);
    };
  }, [enabled]);
  if (!rows || !user) return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("style", { children: switcherCss(rows, user.id) }),
    box && /* @__PURE__ */ jsx(SwitcherSearch, { rows, box })
  ] });
}
export function legacyOptionLabel(row, hasStats) {
  var _a, _b, _c;
  if (!hasStats) return row.name;
  const name = row.name.length > LEGACY_NAME_CHARS ? row.name.slice(0, LEGACY_NAME_CHARS - 1) + "\u2026" : row.name;
  const status = row.stats ? statusColumn(row.stats).text : "";
  const count = ((_b = (_a = row.stats) == null ? void 0 : _a.itemCount) != null ? _b : 0) > 0 ? String((_c = row.stats) == null ? void 0 : _c.itemCount) : "";
  const text = status.padEnd(12) + "  " + name.padEnd(LEGACY_NAME_CHARS) + "  " + count.padStart(3);
  return text.trimEnd().replace(/ /g, "\xA0");
}
export function managedIndexerLegacySelect(user) {
  const rows = currentRows(user);
  if (!rows) return null;
  const hasStats = hasAnyStats(rows);
  const groups = [];
  rows.forEach((row) => {
    if (row.kind === "heading") {
      groups.push({ title: row.title.toUpperCase(), accounts: [] });
    } else {
      groups[groups.length - 1].accounts.push(row);
    }
  });
  return {
    // The select is normally 200px wide, too narrow for the columns.
    style: {
      fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
      width: "auto"
    },
    options: groups.map((group) => (
      // Keyed by the section, not its label, which changes with the late count; a new key would
      // rebuild the options and lose the select's current account.
      /* @__PURE__ */ jsx("optgroup", { label: group.title, children: group.accounts.map(
        (row) => row.kind === "account" && /* @__PURE__ */ jsx("option", { value: row.userId, children: legacyOptionLabel(row, hasStats) }, row.userId)
      ) }, group.title.split(" \xB7 ")[0])
    ))
  };
}
function toSnapshot(response, fetchedAt) {
  if (!response.enabled) return null;
  return {
    fetchedAt,
    priorities: new Map(response.accounts.map((a) => [a.user_id, a.priority])),
    stats: new Map(response.accounts.map((a) => [a.user_id, a]))
  };
}
function isSwitcherOpen() {
  var _a;
  return !!document.getElementById(ACCOUNT_LIST_ID) || !!((_a = document.activeElement) == null ? void 0 : _a.classList.contains(LEGACY_SELECT_CLASS));
}
function show(snapshot) {
  clearTimeout(heldTimer);
  if (!snapshot && !shown) {
    held = void 0;
    return;
  }
  held = snapshot;
  if (isSwitcherOpen()) {
    heldTimer = setTimeout(() => show(held != null ? held : null), HELD_RETRY_MS);
    return;
  }
  held = void 0;
  shown = snapshot;
  notify();
}
function sessionCacheKey(groupUsers) {
  const userIds = groupUsers.map((groupUser) => groupUser.user_id).sort((a, b) => a - b);
  return `${SESSION_CACHE_KEY}:${userIds.join(",")}`;
}
export function restoreManagedIndexerSwitcher() {
  const user = eligibleUser();
  if (user) restoreFromSession(user);
}
function restoreFromSession(user) {
  try {
    const cached = sessionStorage.getItem(
      sessionCacheKey(user.group_user_info)
    );
    if (!cached) return;
    const { fetchedAt, response } = JSON.parse(cached);
    if (Date.now() - fetchedAt > SESSION_CACHE_MAX_AGE_MS) return;
    shown = toSnapshot(decodeManagedIndexerSwitcher(response), fetchedAt);
  } catch (e) {
  }
}
function eligibleUser() {
  var _a;
  const user = Auth.getCurrentUser();
  return (user == null ? void 0 : user.managed_indexer) && ((_a = user.group_user_info) == null ? void 0 : _a.length) ? user : null;
}
function refresh() {
  const user = eligibleUser();
  if (!user) return;
  managedIndexerSwitcherServiceShow({}).then((response) => {
    const fetchedAt = Date.now();
    try {
      sessionStorage.setItem(
        sessionCacheKey(user.group_user_info),
        JSON.stringify({
          fetchedAt,
          response: encodeManagedIndexerSwitcher(response)
        })
      );
    } catch (e) {
    }
    show(toSnapshot(response, fetchedAt));
  }).catch(() => {
    if (held !== void 0) show(held);
    else if (shown) show(__spreadProps(__spreadValues({}, shown), { stats: null }));
  });
}
export function startManagedIndexerSwitcher(onChange) {
  notify = onChange;
  if (refreshTimer) {
    refresh();
    return;
  }
  refresh();
  refreshTimer = setInterval(refresh, REFRESH_MS);
}
export function clearManagedIndexerSwitcher() {
  clearTimeout(heldTimer);
  held = void 0;
  shown = null;
}
export function stopManagedIndexerSwitcher() {
  clearInterval(refreshTimer);
  clearTimeout(heldTimer);
  refreshTimer = void 0;
  notify = () => {
  };
}
